import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "siteSearch-hit",
    "data-hit": "magazine"
};
const _hoisted_2 = { class: "cardMod subject--skp_magazine_issue appearance--custom with--image" };
const _hoisted_3 = { class: "cardMod-media" };
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "cardMod-content" };
const _hoisted_7 = { class: "cardMod-title" };
const _hoisted_8 = ["href", "innerHTML"];
const _hoisted_9 = ["href"];
import { ThemeIcon } from "../../index";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Magazine',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("article", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            href: _ctx.document.url
                        }, [
                            _createElementVNode("img", {
                                src: _ctx.document.cover_image_url,
                                alt: ""
                            }, null, 8, _hoisted_5)
                        ], 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "cardMod-pretitle" }, "Skolportens magasin", -1)),
                        _createElementVNode("h4", _hoisted_7, [
                            _createElementVNode("a", {
                                href: _ctx.document.url,
                                innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.title) || _ctx.document.title
                            }, null, 8, _hoisted_8)
                        ])
                    ]),
                    _createElementVNode("a", {
                        class: "cardMod-link",
                        href: _ctx.document.url,
                        title: "Läs mer och prenumerera"
                    }, [
                        _createVNode(_unref(ThemeIcon), { name: "arrow-right-long" }),
                        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Läs mer och prenumerera", -1))
                    ], 8, _hoisted_9)
                ])
            ]));
        };
    }
});
